<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []

    if (icon) {
      if (icon.includes('el-icon')) {
        vnodes.push(<i class={[icon, 'sub-el-icon']} style="vertical-align: middle; margin-right: 10px"/>)
      } else {
        vnodes.push(<svg-icon icon-class={icon} style="font-size: 20px;vertical-align: middle; margin-right: 10px"/>)
      }
    }

    if (title) {
      vnodes.push(<span slot='title' style="font-size: 16px; vertical-align: middle;">{(title)}</span>)
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
  font-size: 20px;
}
</style>
